import React, { useEffect, useLayoutEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";
import { getBanners } from "../../../../redux/app/actions";
import { useDispatch } from "react-redux";
import { useState } from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import Footer from "../../../../containers/Footer";
import MainSlider from "../../../../containers/MainSlider";

import { casinoSliderData, casinoTabs } from "../../../../lib/data";
import ImageCard from "../../../components/imageCard";
import { AiOutlineSearch } from "react-icons/ai";
import { BsFillCloudFill } from "react-icons/bs";
import SliderSection from "../../../components/sliderSection";
import { RxCross1 } from "react-icons/rx";
import { gsap } from "gsap";

import EzugiProvider from "../../../../assets/images/providers/Ezugiprovider.png";
import EvolutionProvider from "../../../../assets/images/providers/EvolutionProvider.png";
import VivoProvider from "../../../../assets/images/providers/Vivoprovider.png";
import XPGProvider from "../../../../assets/images/providers/XPGprovi.png";
import SNProvider from "../../../../assets/images/providers/Supernowaprovider.png";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";

import OverviewIcon from "../../../../assets/images/icons/casino/search.png";
import RouletteIcon from "../../../../assets/images/icons/casino/roulette.png";
import BlackjackIcon from "../../../../assets/images/icons/casino/bacccrat.png";
import VivoIcon from "../../../../assets/images/icons/casino/playing-card.png";
import PokerIcon from "../../../../assets/images/icons/casino/poker.png";
import SpribeIcon from "../../../../assets/images/icons/casino/airplane.png";
import TvIcon from "../../../../assets/images/icons/casino/game-controller.png";
import GameLobbyIcon from "../../../../assets/images/icons/casino/board-game.png";
import AllIcon from "../../../../assets/images/icons/casino/select-all.png";
import BaccarartIcon from "../../../../assets/images/icons/casino/baccarat.png";
import SupernowaIcon from "../../../../assets/images/icons/casino/casino-chip.png";

const PROVIDERS = [
  { id: 0, name: "Vivo", key: "vivo" },
  { id: 1, name: "Evolution", key: "evolution" },
  { id: 2, name: "Ezugi", key: "ezugi" },
];

const categoriesTab = [
  {
    name: "Overview",
    img: OverviewIcon,
  },
  {
    name: "Roulette",
    img: RouletteIcon,
  },
  {
    name: "Blackjack",
    img: BlackjackIcon,
  },
  {
    name: "Baccarat",
    img: BaccarartIcon,
  },
  {
    name: "Poker",
    img: PokerIcon,
  },
  {
    name: "Spribe",
    img: SpribeIcon,
  },
  {
    name: "Vivo",
    img: VivoIcon,
  },
  {
    name: "Supernowa",
    img: SupernowaIcon,
  },
  {
    name: "TV Games",
    img: TvIcon,
  },
  {
    name: "All Games",
    img: AllIcon,
  },
  {
    name: "Game Lobby",
    img: GameLobbyIcon,
  },
];

const Casino = ({ showLayout = true }) => {
  const { isAuth } = useSelector((state) => state.auth);
  const container = useRef();
  const tl = useRef();
  const location = useLocation();
  const { banners } = useSelector((state) => state.app);
  const [isSearched, setIsSearched] = useState(null);
  const [searchedText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [activeCategory, setActiveCategory] = useState("Overview");
  const [selectedProvider, setSelectedProvider] = useState(null);

  useEffect(() => {
    if (location?.state?.activeCategory === "Game Lobby") {
      setActiveCategory("Game Lobby");
    }
    if (location?.state?.activeCategory === "Overview") {
      setActiveCategory("Overview");
    }
  }, [location]);

  const [showSlider, setShowSlider] = useState({
    show: true,
    category: "Overview",
    showMultipleSlides: {
      Popular: false,
      Roulette: true,
      Blackjack: true,
      Baccarat: true,
      Poker: false,
      Spribe: false,
      Supernowa: true,
      Vivo: false,

      // "Pragmatic Play": "true",
      "TV Games": false,
      "All Games": true,
      "Game Lobby": false,
    },
  });

  const [sliderPageNumber, setSliderPageNumber] = useState({
    Popular: 1,
    Roulette: 1,
    Blackjack: 1,
    Baccarat: 1,
    Poker: 1,
    Spribe: 1,
    Supernowa: 1,
    Vivo: 1,
    // PragmaticPlay: 1,
    "TV Games": 1,
    "All Games": 1,
    "Game Lobby": 1,
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getBanners());
  }, []);

  const handleSearch = (e) => {
    setSearchText(e?.target?.value);
    const value = e?.target?.value?.toLowerCase();

    if (value) {
      setIsSearched(true);
      let filteredValues = [];

      Object.values(casinoTabs).forEach((slide) => {
        if (slide.name !== "All Games") {
          Object.values(slide).map((item, index) => {
            if (typeof item !== "string") {
              let response = Object.values(item).filter(
                (f) =>
                  f?.name
                    ?.toLowerCase()
                    .trim()
                    ?.indexOf(value.toLowerCase().trim()) > -1
              );
              let clone = [...filteredValues];
              clone = [...clone, ...response];
              filteredValues = clone;
            }
          });
        }
      });

      setFilteredData(filteredValues);
    } else {
      setIsSearched(false);
    }
  };

  const settings1 = {
    dots: false,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  useLayoutEffect(() => {
    const ctx = gsap.context((self) => {
      const boxes = self.selector(".dot");
      tl.current = gsap
        .timeline()
        .to(boxes[0], { x: 250 })

        .reverse();
    }, container); // <- Scope!
    return () => ctx.revert(); // <- Cleanup!
  }, []);

  const toggleTimeline = () => {
    tl.current.reversed(!tl.current.reversed());
  };

  return (
    <>
      {showLayout && (
        <>
          {isAuth ? (
            <HeaderAfterLogin toggleDefault={false} />
          ) : (
            <Header Casino={true} />
          )}
        </>
      )}

      <main className="main GamesSection SlotsSectionNew onlycasinogame">
        {showLayout && (
          <>
            <div className="mainBanner">
              <MainSlider banners={banners} />
            </div>

            <div className="provideradded-section d-none">
              <Slider {...settings1}>
                <div className="provider-imagess">
                  <a href="/casino/aggapezugi-ezugi-lobby" className="provider-img">
                    <img src={EzugiProvider} alt="Ezugi Provider" />
                  </a>
                </div>
                <div className="provider-imagess">
                  <a href="/casino/evolution" className="provider-img">
                    <img src={EvolutionProvider} alt="Ezugi Provider" />
                  </a>
                </div>
                <div className="provider-imagess">
                  <a href="/casino/vivo" className="provider-img">
                    <img src={VivoProvider} alt="Ezugi Provider" />
                  </a>
                </div>
                <div className="provider-imagess">
                  <a href="/casino/xpg" className="provider-img">
                    <img src={XPGProvider} alt="Ezugi Provider" />
                  </a>
                </div>

                <div className="provider-imagess">
                  <a href="/casino/supernowa" className="provider-img">
                    <img src={SNProvider} alt="Ezugi Provider" />
                  </a>
                </div>
              </Slider>
            </div>
          </>
        )}

        <div className="ContainerCss">
          <div className="casino-category filters">
            <ul>
              {categoriesTab.map((tab, index) => (
                <li
                  key={index}
                  onClick={() => {
                    setShowSlider((p) => ({
                      category: tab?.name,
                      show: true,
                      ...p,
                    }));
                    setActiveCategory(tab?.name);
                  }}
                >
                  <a
                    href="#"
                    style={
                      activeCategory === tab?.name
                        ? {
                            color: "#ffb900",
                            borderBottom: "3px solid #ffb900",
                          }
                        : {}
                    }
                    className={activeCategory === tab?.name ? "active" : ""}
                  >
                    <img src={tab?.img} alt="roulette" />
                    {tab?.name}
                  </a>
                </li>
              ))}
            </ul>

            <div className="search-prvdr">
              <div className="search" ref={container}>
                <input
                  id="search-bar"
                  type="text"
                  placeholder="Search"
                  value={searchedText}
                  onChange={handleSearch}
                />
                <AiOutlineSearch className="lens" />
              </div>

              <Dropdown className="provider-filter">
                <Dropdown.Toggle variant="" id="dropdown-basic">
                  {selectedProvider
                    ? PROVIDERS.find((f) => f?.key === selectedProvider)?.name
                    : "Provider Filter"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {PROVIDERS.map((provider, idx) => {
                    return (
                      <Dropdown.Item
                        key={idx}
                        onClick={() => setSelectedProvider(provider.key)}
                      >
                        {provider.name}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <SliderSection
            isSearched={isSearched}
            activeCategory={activeCategory}
            data={casinoSliderData}
            sliderPageNumber={sliderPageNumber}
            isAuth={isAuth}
            showSlider={showSlider}
            filteredData={filteredData}
            setSliderPageNumber={setSliderPageNumber}
            setShowSlider={setShowSlider}
            selectedProvider={selectedProvider}
          />
        </div>
      </main>

      {showLayout && <Footer />}
    </>
  );
};

export default Casino;
